$bog_merchquarium_settings $mol_page
	title @ \Settings
	Import_summary @ \Will add products: {products}, new categories: {categories}, new fandoms: {fandoms}, new links: {links}
	Import_errors @ \Problems: {errors}
	Theme_sakura @ \Sakura
	Theme_lavender @ \Lavender
	Theme_mint @ \Mint
	Theme_peach @ \Peach
	Theme_sky @ \Sky
	Theme_milk @ \Milk
	Theme_classic @ \Classic
	catalog_link? \
	head /
		<= Title
		<= Lang $mol_locale_select
			dictionary *
				ru \Русский
				en \English
		<= Tools
	tools /
		<= Sync $giper_baza_status
	body /
		<= Account_section $mol_section
			title @ \Account
			content /
				<= Account_label $mol_paragraph
					title @ \Your account id:
				<= Account_lord $mol_paragraph
					title <= account_lord \
				<= Account_id $mol_button_copy
					title <= account_id \
		<= Look_section $mol_section
			title @ \Appearance
			content /
				<= Catalog_title $mol_string
					hint @ \Catalog title
					value? <=> catalog_title? \
				<= Images $mol_view
					sub /
						<= Image_field*Avatar
						<= Image_field*Cover
						<= Image_field*Back
				<= Themes $mol_view
					sub <= theme_options /
				<= Listed $mol_check_box
					title @ \Show in search engines
					checked? <=> listed? true
		<= Sales_section $mol_section
			title @ \Sales
			content /
				<= Social_link $mol_string
					hint @ \Link for orders: @nick or t.me/nick
					value? <=> social_link? \
				<= Social_text $mol_string
					hint @ \Request message: {count} items, {total} sum, {title} names, {link} order link
					value? <=> social_text? \
				<= Links_label $mol_paragraph
					title @ \Other socials in the header
				<= Links $bog_merchquarium_tags
					items <= link_items /string
					editable <= is_admin false
					input_hint @ \vk.com/nick, youtube.com/@nick
					item_add*? <=> link_add*? null
					item_drop*? <=> link_drop*? null
		<= Categories_section $mol_section
			title @ \Merch kinds
			content /
				<= Categories $bog_merchquarium_tags
					items <= category_items /string
					editable <= is_admin
					input_hint @ \New merch kind
					confirm_title @ \Delete this merch kind?
					usage* <= category_usage* 0
					item_add*? <=> category_add*? null
					item_drop*? <=> category_drop*? null
		<= Fandoms_section $mol_section
			title @ \Fandoms
			content /
				<= Fandoms $bog_merchquarium_tags
					items <= fandom_items /string
					editable <= is_admin
					input_hint @ \New fandom
					marker \#
					confirm_title @ \Delete this fandom?
					usage* <= fandom_usage* 0
					item_add*? <=> fandom_add*? null
					item_drop*? <=> fandom_drop*? null
		<= Import_section $mol_section
			title @ \Bulk import
			content /
				<= Import_hint $mol_paragraph
					title @ \Copy the prompt, talk to any AI chat and paste its JSON below. Upload photos to the cards afterwards.
				<= Import_prompt $mol_button_copy
					title @ \Copy prompt for AI
					text <= import_prompt \
				<= Import_json $mol_textarea
					hint @ \Paste JSON here
					value? <=> import_json? \
				<= Import_preview $mol_paragraph
					title <= import_preview \
				<= Import_run $mol_button_major
					title @ \Create products
					click? <=> import_run? null
					enabled <= import_ready false
		<= Access_section $mol_section
			title @ \Access
			content /
				<= Debug_info $mol_paragraph
					title <= debug_info \
				<= Rights $giper_baza_land_rights
					land <= catalog_land null
	Image_field* $mol_view
		sub /
			<= Image_preview* $mol_view
				style <= image_style* *
			<= Image_actions* $mol_view
				sub /
					<= Image_pick* $mol_button_open
						files? <=> image_add*? /File
						multiple false
						accept \image/*
						sub /
							^
							<= image_title* \
					<= Image_drop* $mol_button_minor
						hint @ \Remove image
						enabled <= image_filled* false
						click? <=> image_drop*? null
						sub /
							<= Image_drop_icon* $mol_icon_close
	Image_avatar @ \Avatar
	Image_cover @ \Header background
	Image_back @ \Page background
	Theme_option* $mol_button_minor
		click? <=> theme_select*? null
		sub /
			<= Theme_swatch* $mol_view
				style <= theme_swatch* *
			<= Theme_name* $mol_view
				sub /
					<= theme_name* \
